var exports = {
  "uW": "PurchaseHistorySection.module__section___Q2VxMk",
  "Nr": "PurchaseHistorySection.module__card___Q2VxMk",
  "Vg": "PurchaseHistorySection.module__grid___Q2VxMk",
  "Qs": "PurchaseHistorySection.module__content___Q2VxMk",
  "DD": "PurchaseHistorySection.module__title___Q2VxMk",
  "h_": "PurchaseHistorySection.module__description___Q2VxMk",
  "be": "PurchaseHistorySection.module__accordionStack___Q2VxMk",
  "JC": "PurchaseHistorySection.module__accordion___Q2VxMk",
  "x6": "PurchaseHistorySection.module__button___Q2VxMk",
};

module.exports = exports;
